import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle9() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article9" headerImage="gasburner.jpg" photographer=" Photo by Pixabay: https://www.pexels.com/photo/burning-stove-266896/" />
        <Footer />
    </div>
  )
}
